(() => {
  let scheduled = false;
  const update = () => {
    scheduled = false;
    const mobile = matchMedia('(max-width:1023px)').matches;
    const open = mobile && Boolean(document.querySelector('.main-menu__disclosure[open], .sa-menu[open], dialog[open], .drawer[open]'));
    document.documentElement.classList.toggle('sa-selection-open', open);
  };
  const schedule = () => {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(update);
  };
  const init = () => {
    new MutationObserver(schedule).observe(document.body, {subtree:true,childList:true,attributes:true,attributeFilter:['open','aria-hidden']});
    matchMedia('(max-width:1023px)').addEventListener('change', schedule);
    document.addEventListener('toggle', schedule, true);
    update();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',init,{once:true});
  else init();
})();
